import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import AddPromoCode from './AddPromoCode';
import { restrictUrls } from '../../../../helpers/adminPrivileges';
import messages from '../../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.addPromoCodeHead);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }
  // Admin restriction
  if (!restrictUrls('/siteadmin/promo-code/add', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  let currency = store.getState().siteSettings.data.currency;
  let initialValues = {
    currency: currency,
    promoCurrency: currency,
  }
  return {
    title,
    component: (
      <AdminLayout>
        <AddPromoCode title={title} initialValues={initialValues}/>
      </AdminLayout>
    ),
  };
}

export default action;
